module.exports = __webpack_public_path__ + "static/media/de.d810f621.svg";